import React from "react";
import { Card, CardBody, Col, Row,Spinner } from "reactstrap";

const UserPanel = ({ overallDataCards = {},loading1 } ) => {
  const {
    university = "0",
    teacher = "0",
    student = "0",
    total_calls = "0",
    total_classrooms = "0",
    // units = { total_units: "" },
    total_units="0",
    total_messages = "0",
    total_mails = "0",
  } = overallDataCards;

  return (
    <React.Fragment>
      <div>
        <Card className="mb-2">
        {loading1 ? ( // Show loader while loading
                  <div
                    className="d-flex justify-content-center align-items-center"
                    style={{ height: "200px" }}
                  >
                    <Spinner style={{ width: "3rem", height: "3rem" }} />
                  </div>
                ) : (
          <CardBody>
            <div>
              <Row className="g-2">
                <Col xl={3} sm={6}>
                  <Card className="minty-gradient border-green mb-0 h-100">
                    <CardBody>
                      <div className="">
                        <div className="mb-2">
                          <p className="f-14 semibold">University</p>
                        </div>

                        <div className="flex-grow-1 flex-wrap gap-2 d-flex justify-content-between align-items-center overflow-hidden">
                          <h4 className="bold">{university}</h4>
                        </div>
                      </div>
                    </CardBody>
                  </Card>
                </Col>
                <Col xl={3} sm={6}>
                  <Card className="peachy-gradient border-red mb-0 h-100">
                    <CardBody>
                      <div className="">
                        <div className="mb-2">
                          <p className="f-14 semibold">Linc Fellow</p>
                        </div>

                        <div className="flex-grow-1 flex-wrap gap-2 d-flex justify-content-between align-items-center overflow-hidden">
                          <h4 className="bold">{teacher}</h4>
                        </div>
                      </div>
                    </CardBody>
                  </Card>
                </Col>
                <Col xl={3} sm={6}>
                  <Card className="sky-gradient border-sky mb-0 h-100">
                    <CardBody>
                      <div className="">
                        <div className="mb-2">
                          <p className="f-14 semibold">Student Name</p>
                        </div>

                        <div className="flex-grow-1 flex-wrap gap-2 d-flex justify-content-between align-items-center overflow-hidden">
                          <h4 className="bold">{student}</h4>
                        </div>
                      </div>
                    </CardBody>
                  </Card>
                </Col>
                <Col xl={3} sm={6}>
                  <Card className="blush-gradient border-red  mb-0 h-100">
                    <CardBody>
                      <div className="">
                        <div className="mb-2">
                          <p className="f-14 semibold">Total Calls</p>
                        </div>

                        <div className="flex-grow-1 flex-wrap gap-2 d-flex justify-content-between align-items-center overflow-hidden">
                          <h4 className="bold">{total_calls}</h4>
                        </div>
                      </div>
                    </CardBody>
                  </Card>
                </Col>
                <Col xl={3} sm={6}>
                  <Card className="peach-blossom-gradient border-yellow  mb-0 h-100">
                    <CardBody>
                      <div className="">
                        <div className="mb-2">
                          <p className="f-14 semibold">Total Classrooms</p>
                        </div>

                        <div className="flex-grow-1 flex-wrap gap-2 d-flex justify-content-between align-items-center overflow-hidden">
                          <h4 className="bold">{total_classrooms}</h4>
                        </div>
                      </div>
                    </CardBody>
                  </Card>
                </Col>
                <Col xl={3} sm={6}>
                  <Card className="light-blue-gradient  border-sky  mb-0 h-100">
                    <CardBody>
                      <div className="">
                        <div className="mb-2">
                          <p className="f-14 semibold">Total Units</p>
                        </div>

                        <div className="flex-grow-1 flex-wrap gap-2 d-flex justify-content-between align-items-center overflow-hidden">
                          <h4 className="bold">{total_units}</h4>
                        </div>
                      </div>
                    </CardBody>
                  </Card>
                </Col>
                <Col xl={3} sm={6}>
                  <Card className="peach-blossom-gradient border-yellow  mb-0 h-100">
                    <CardBody>
                      <div className="">
                        <div className="mb-2">
                          <p className="f-14 semibold">Total Messages</p>
                        </div>

                        <div className="flex-grow-1 flex-wrap gap-2 d-flex justify-content-between align-items-center overflow-hidden">
                          <h4 className="bold">{total_messages}</h4>
                        </div>
                      </div>
                    </CardBody>
                  </Card>
                </Col>
                <Col xl={3} sm={6}>
                  <Card className="lavender-gradient border-lavender  mb-0 h-100">
                    <CardBody>
                      <div className="">
                        <div className="mb-2">
                          <p className="f-14 semibold">Total Mails</p>
                        </div>

                        <div className="flex-grow-1 flex-wrap gap-2 d-flex justify-content-between align-items-center overflow-hidden">
                          <h4 className="bold">{total_mails}</h4>
                        </div>
                      </div>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </div>
          </CardBody>
                )}
        </Card>
      </div>
    </React.Fragment>
  );
};

export default UserPanel;
